/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RangeSelect/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function RangeSelect({
  children,
  viewPath = "/DesignSystem/TysiaInputDateRange/TysiaDateRange/RangeSelect",
  onClick,
  isSelected
  
}) {
let rangeTextValueData = fromData.useDataValue({ viewPath,
context: 'range',
path: 'text',
})
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 justifyContent="center"
 onClick={onClick}
 type={isSelected ? "primary" : "secondary"}
 size="small"
 width={84}
 data="range.text"
 text={rangeTextValueData}
/>
{children}
</React.Fragment>)
}